import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=3cb731f1&scoped=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=3cb731f1&prod&lang=scss&scoped=true"
import style1 from "./SettingsLayout.vue?vue&type=style&index=1&id=3cb731f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb731f1",
  null
  
)

export default component.exports